import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { MdOutlineOilBarrel, MdOutlineQueryBuilder, MdOutlineQuestionMark, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { useAuthState } from "../../context/AuthContext";
import { BsGearFill } from "react-icons/bs";
import AreYouSureModal from "../shared/AreYouSureModal";
import PrivateApi from "../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import EnergoTooltip from "../shared/EnergoTooltip";
import { TiThMenu } from "react-icons/ti";
import { FaCheck } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";



/**
 * 
 * @param {props} building object data of building
 * @param {props} anlage object data of anlage
 * @param {props} elv array of elvs object if present
 * @param {props} ticket array of ticket objects if present
 * @param {props} changeModal function to handle modal
 * @param {props} switchHandler function to handle modal
 * @param {props} inCreation boolean if card should be opaque 
 * 
 * @returns Card
 */
const TopSwitchAnlageCard = ({ building, anlage, elv, ticket, changeModal, switchHandler, inCreation }) => {

    const API = new PrivateApi();
    const { contactPerson, tooltips, tooltipsTrigger } = useAuthState();
    const queryClient = useQueryClient();
    let headerBg = null; // header color for different energy
    let icon = <MdOutlineQuestionMark size={30} />; // default icon
    const { user } = useAuthState();
    const [areYouSure, setAreYouSure] = useState(false);
    const [yesLoading, setYesLoading] = useState(false);

    // change header color and icons according to energy type
    if (anlage.x_studio_field_3eKe0 === "Strom") { headerBg = '#a2c13f'; icon = <SlEnergy size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Gas") { headerBg = '#3fbfbf'; icon = <TbFlame size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Oil") { headerBg = '#a2c13f'; icon = <MdOutlineOilBarrel size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Strom-Einspeisung") { headerBg = '#ffc107'; icon = <MdOutlineSolarPower size={30} />; }

    const [switchBool, setSwitchBool] = useState(elv && elv.length > 0 && (elv[0].x_kunde_id[0] === building.id || elv[0].x_kunde_id[0] === user.id) ? true : false)

    const closeTicketHandler = () => {
        setYesLoading(true);
        var data = {ticket_id: ticket[0].id, user: contactPerson.name}
        API.post_Ticket_close(data)
            .then(() => {
                console.log("here");
                queryClient.invalidateQueries("GET_ALL_BUILDING_INFO_QUERY");
                setYesLoading(false);
                setAreYouSure(false);
                setSwitchBool(elv && elv.length > 0 && (elv[0].x_kunde_id[0] === building.id || elv[0].x_kunde_id[0] === user.id) ? true : false);
            });
    }

    useEffect(() => {
        setSwitchBool(elv && elv.length > 0 && (elv[0].x_kunde_id[0] === building.id || elv[0].x_kunde_id[0] === user.id) ? true : false);
    }, [elv])

    return (
        <Card className="mt-3 shadow-lg rounded text-start" id={`anlageCard-${anlage.x_studio_field_mWMGR}`}>
            <Card.Header className="text-white" style={inCreation ? { opacity: 0.4, background: headerBg } : { background: headerBg }}>
                <div className="border border-2 rounded-circle energo-card-header-icon">
                    {icon}
                </div>
                <div className="adjust-font-on-small energo-card-header-icon-text">
                    {
                        anlage.x_anlagenverwendung === "Wohnung" || anlage.x_anlagenverwendung === "Gewerbe" ? anlage.x_anlagenverwendung :
                            anlage.x_anlagenverwendung_detail !== "False" ? anlage.x_anlagenverwendung_detail : null
                    }
                </div>
                <div hidden={anlage.x_studio_field_mWMGR === "new" || anlage.x_studio_field_mWMGR === "False"} className="energo-card-header-action">
                    <button className="btn btn-link text-white" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                        <TiThMenu className="text-warning" size={30} />
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li key={"edit"} className="text-center">
                            <a onClick={e => { e.preventDefault(); changeModal(anlage) }} href="/anlage/ändern/" className="link-energo">Ändern / Frage</a>
                        </li>
                    </ul>
                </div>
                <div style={{ display: "inline-block", float: "right", paddingTop: "5px" }}>
                    {anlage.x_studio_field_mWMGR !== "new" ?
                        <span style={{ fontSize: "30px", fontWeight: "300" }}>{anlage.x_studio_field_mWMGR}</span>
                        :
                        <MdOutlineQueryBuilder size={40} />
                    }
                </div>
            </Card.Header>
            <Card.Body>
                <Row className="mt-3">
                    <Col xl="8" style={inCreation ? { opacity: 0.4 } : null}>
                        {anlage.x_adresse_kompakt !== "False" && anlage.x_adresse_kompakt !== "" &&
                            <p>Anlagenadresse &nbsp; <small className="text-muted">{anlage.x_adresse_kompakt}</small></p>
                        }
                        {anlage.x_anlagenverwendung !== "False" ?
                            <p>Anlagenverwendung &nbsp; <small className="text-muted">{anlage.x_anlagenverwendung}</small></p>
                            : null
                        }
                        
                        {anlage.x_bestandseinheitennummer !== "False" && anlage.x_bestandseinheitennummer !== anlage.x_studio_field_6T9W2 ?
                            <p>Bestandseinheitnummer &nbsp; <small className="text-muted">{anlage.x_bestandseinheitennummer}</small></p> :
                            null
                        }
                        {
                            elv && elv.length > 0 ?
                                <p>Aktueller Vertragspartner &nbsp; <small className="text-muted">
                                    {
                                        elv[0].x_kunde_id[0] === building.id ? elv[0].x_kunde_id[1].length > 33 ? `${elv[0].x_kunde_id[1].substring(0, 30)}...` : elv[0].x_kunde_id[1] :
                                            elv[0].x_kunde_id[0] === user.id ? user.name :
                                                'Drittpartei'
                                    }
                                </small>
                                </p>
                                :
                                inCreation && anlage['Anlage anmelden am'] !== undefined ?
                                    <p>Anmeldung per Datum &nbsp; <small className="text-muted">{new Date(anlage['Anlage anmelden am']).toLocaleDateString('DE-de')}</small></p> :
                                    inCreation && anlage['Anlage anmelden am'] === undefined ?
                                        <p>Anmeldung per Datum &nbsp; <small className="text-muted">Nicht anmelden</small></p> :
                                        <p>Aktueller Vertragspartner &nbsp; <small className="text-muted">Nicht angemeldet</small></p>
                        }
                        {anlage.x_zaehlernummer_02 === "" || anlage.x_zaehlernummer_02 === "False" ?
                            <>
                                <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                                <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                                {anlage.x_lastprofil_01 !== "False" ?
                                    <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p> : null
                                }
                                {anlage.x_is_smartmeter_01 !== undefined || anlage.x_is_smartmeter_01 !== "False" ? 
                                    <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                                    :null
                                }
                            </>
                            : null}
                    </Col>
                    <Col xl="4" className="text-center">
                    {anlage.x_messtechnik_variante !== "Direktverrechnung" &&
                        <p className="text-muted">
                            {
                                ticket && ticket.length > 0 ?
                                    ticket[0].ticket_type_id[0] === 15 ? 'Anmeldung im Gange' :
                                        ticket[0].ticket_type_id[0] === 16 ? 'Abmeldung im Gange' :
                                            ticket[0].ticket_type_id[0] === 17 ? 'Anlage wird hinzugefügt' : null
                                    :
                                    elv && elv.length > 0 ?
                                        (elv[0].x_kunde_id[0] === building.id || elv[0].x_kunde_id[0] === user.id) && elv[0].x_is_leerstand ? 'Leerstand angemeldet' :
                                                (elv[0].x_kunde_id[0] === building.id || elv[0].x_kunde_id[0] === user.id) && (anlage.x_studio_field_6T9W2 === "False" || anlage.x_adresse_abw_top === "False") ? 'Anlage angemeldet' :
                                                    'Anlage abgemeldet' :
                                        'Anlage abgemeldet'
                            }
                        </p>
                    }
                        {anlage.x_messtechnik_variante === "Direktverrechnung" && 
                            <div className="mt-4">
                                <p className="text-danger">Direktverrechnung durch <br/>{anlage.x_messtechnik_id[1]}</p>
                                <EnergoTooltip tKey="2004" position="bottom" />
                            </div>
                        }
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}} hidden={(ticket && ticket.length > 0) || anlage.x_messtechnik_id.length > 0 && anlage.x_messtechnik_variante === "Direktverrechnung"}>
                            <Form.Check
                                hidden={anlage.x_messtechnik_variante === "Direktverrechnung"}
                                id={`switch-${anlage.id}`}
                                className="switch-energo"
                                style={{marginRight: "10px"}}
                                type="switch"
                                defaultChecked={switchBool}
                                value={switchBool}
                                onChange={e => { switchHandler(anlage); setSwitchBool(!e.target.checked) }}
                            />
                            <EnergoTooltip tKey="2001" position="right" />
                        </div>
                        {ticket !== undefined && ticket.length > 0 ?
                            <>
                                <p>
                                    <BsGearFill hidden={ticket === undefined || ticket.length === 0} size={40} style={{ marginTop: "-8px" }} className="text-energo rotating" />
                                </p>
                                <Button variant="danger" onClick={() => setAreYouSure(true)}>Abbrechen</Button>
                                <br /><br />
                                <AreYouSureModal
                                    show={areYouSure}
                                    setShow={setAreYouSure}
                                    title="Aktion abbrechen"
                                    message="Sind Sie sicher, dass Sie die Aktion abbrechen wollen?"
                                    yesHandler={() => closeTicketHandler()}
                                    loading={yesLoading}
                                />
                            </>
                        :null}
                        {elv && elv.length > 0 && (elv[0].x_kunde_id[0] === building.id || elv[0].x_kunde_id[0] === user.id) ?
                            <>
                                <br hidden={ticket && ticket.length > 0} />
                                <a hidden={anlage.x_messtechnik_id.length > 0 && anlage.x_messtechnik_variante === "Direktverrechnung"} style={{ fontSize: "17px" }} href={`/hw/dashboard/energieliefervertraege/${elv[0].id}`} className="link-energo">Energieliefervertrag ansehen</a>
                            </>
                            : null
                        }
                    </Col>
                </Row>
                <Row className="mt-5" style={inCreation ? { opacity: 0.4 } : null}>
                    {anlage.x_zaehlernummer_02 !== "" && anlage.x_zaehlpunktnummer_02 !== "False" ?
                        <Col className={anlage.x_zaehlpunktnummer_02 ? 'border-right' : null} xs="12" md={anlage.x_zaehlpunktnummer_02 ? "6" : "12"} xl={anlage.x_zaehlpunktnummer_02 ? "6" : "12"}>
                            <p className="text-center">Zählpunkt 1</p>
                            <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                            <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                            {anlage.x_lastprofil_01 !== "False" ?
                                <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p> : null
                            }
                            {anlage.x_is_smartmeter_01 !== undefined || anlage.x_is_smartmeter_01 !== "False" ? 
                                <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                                :null
                            }
                        </Col>
                        : null}
                    {anlage.x_zaehlpunktnummer_02 && anlage.x_zaehlpunktnummer_02 !== "False" ?
                        <Col xs="12" md="6" xl="6">
                            <p className="text-center">Zählpunkt 2</p>
                            <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                            <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                            {anlage.x_lastprofil_02 !== "False" ? (
                                <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_02}</small></p>
                            ) : null}
                            {anlage.x_is_smartmeter_01 !== undefined || anlage.x_is_smartmeter_01 !== "False" ? 
                                <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                                :null
                            }
                        </Col>
                        :
                        null
                    }
                </Row>
            </Card.Body>
        </Card>
    )
}

export default TopSwitchAnlageCard;